import StarterKit from '@tiptap/starter-kit'
import Placeholder from '@tiptap/extension-placeholder'
import {
  MenuButtonBold,
  MenuButtonItalic,
  MenuControlsContainer,
  MenuDivider,
  MenuSelectHeading,
  RichTextEditor
} from 'mui-tiptap'
import { useEffect, useRef, useState } from 'react'
import '../../Style/RTE.css'
import { Box, IconButton, Tooltip } from '@mui/material'
import { Clear } from '@mui/icons-material'

const RichTextEditorComponent = ({
  label,
  onChange,
  disabled,
  required = false,
  value,
  mb,
  mr,
  keyValue,
  buttons
}) => {
  const rteRef = useRef(null)
  const formatInitialValue = val => {
    if (!val) return '<p></p>'
    if (!val.includes('<p>')) return '<p>' + val + '</p>'
    return val
  }

  const [textValue, setTextValue] = useState(() => formatInitialValue(value))

  useEffect(() => {
    const formatted = formatInitialValue(value)
    if (formatted !== textValue) {
      setTextValue(formatted)
      if (
        rteRef.current?.editor &&
        rteRef.current.editor.getHTML() !== formatted
      ) {
        rteRef.current.editor.commands.setContent(formatted)
      }
    }
  }, [value])

  return (
    <Box sx={{ width: '100%', mb: mb || 0, mr: mr || 0 }}>
      <span className='rteLabel' data-label-for={label + '_editor'}>
        {label}
        {required && ' *'}
      </span>
      {textValue && (
        <RichTextEditor
          key={keyValue + '_editor'}
          ref={rteRef}
          extensions={[
            StarterKit,
            Placeholder.configure({
              placeholder: label + (required ? ' *' : ''),
              emptyEditorClass: 'is-editor-empty'
            })
          ]}
          editable={disabled ? false : true}
          onBlur={() => {
            const html = rteRef.current?.editor?.getHTML()
            onChange(html)
          }}
          editorProps={{
            attributes: {
              id: label + '_editor'
            },
            handleDOMEvents: {
              copy: (view, event) => {
                event.preventDefault()
                const { state } = view
                const { from, to } = state.selection
                const text = state.doc.textBetween(from, to, ' ')

                if (event.clipboardData) {
                  event.clipboardData.setData('text/plain', text)
                }
                return true
              },
              cut: (view, event) => {
                event.preventDefault()
                const { state, dispatch } = view
                const { from, to } = state.selection
                const text = state.doc.textBetween(from, to, ' ')

                if (event.clipboardData) {
                  event.clipboardData.setData('text/plain', text)
                }

                dispatch(state.tr.deleteSelection().scrollIntoView())
                return true
              }
            }
          }}
          content={textValue}
          renderControls={() => (
            <MenuControlsContainer>
              <MenuSelectHeading />
              <MenuDivider />
              <MenuButtonBold />
              <MenuButtonItalic />
              <Box
                sx={{
                  marginLeft: 'auto',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <MenuDivider />
                <Tooltip title={'Clear ' + label}>
                  <span>
                    <IconButton
                      onClick={() => {
                        if (rteRef.current?.editor) {
                          rteRef.current.editor.commands.setContent('<p></p>')
                          onChange('<p></p>')
                        }
                      }}
                    >
                      <Clear />
                    </IconButton>
                  </span>
                </Tooltip>
                {buttons &&
                  buttons.map((ButtonComponent, index) => (
                    <Box
                      key={`custom-btn-${index}` + keyValue}
                      sx={{ display: 'flex' }}
                    >
                      {ButtonComponent}
                    </Box>
                  ))}
              </Box>
            </MenuControlsContainer>
          )}
        />
      )}
    </Box>
  )
}

export default RichTextEditorComponent
